<template>
	<drawer
			title="Add action"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				margin="0"
				width="300px"
				min-height="54px"
				label="Note"
				placeholder="Enter note"
				:setInputValue="note"
				@updateInput="onInput"
				is-textarea
		></field>
	</drawer>
</template>

<script>
import { mapActions } from "vuex";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "ActionDrawer",
	components: { Drawer },
	props: {
		isDrawer: Boolean,
		dataActions: Object,
		editAction: Object,
		dataSort: Object
	},
	data: () => ({
		drawer: null,
		note: ''
	}),
	methods: {
		...mapActions([ 'addShortPaymentsActions', 'onShortPaymentsActions', 'editShortPaymentsActions', 'onShortPaymentsList' ]),
		onInput({ value }) {
			this.note = value;
		},
		onClose(mark) {
			this.drawer = false;
			this.$emit('closeDrawer', mark);
		},
		async onSave() {
			if (this.editAction) {
				const { id } = this.editAction;
				const values = {
					id,
					action_text: this.note
				};

				await this.editShortPaymentsActions(values);

			} else {
				const values = {
					...this.dataActions,
					action_text: this.note
				};

				await this.addShortPaymentsActions(values);
			}

			await this.onShortPaymentsActions(this.dataActions);
			await this.onShortPaymentsList();
			this.onClose(0);
		}
	},
	mounted() {
		this.drawer = this.isDrawer;
		if (this.editAction) this.note = this.editAction.text;
	}
};
</script>
